import { scrollV2 } from '@/arise/api';
import { getDeviceType } from '@/utils/mobile';

let userId = undefined;
let deviceId = window.localStorage.getItem('ARISE_DEVICE_ID');

const sessionId = uuidv4();
const sessionStartTime = Date.now();
const deviceType = getDeviceType();

if (!deviceId) {
    deviceId = uuidv4();
    window.localStorage.setItem('ARISE_DEVICE_ID', deviceId);
}

export function setUserId(id: string) {
    userId = id;
}

// export function sendEvent(name: string, data: any) {
//     return scroll({
//         events: [
//             {
//                 user_id: userId,
//                 device_id: deviceId,
//                 event_type: name,
//                 event_properties: data,
//                 time: new Date().getTime(),

//                 // Platform
//                 ...platformData,
//             },
//         ],
//     }).catch((e) => {
//         // Silently fail
//     });
// }

export function sendEventV2(
    name: string,
    strings: string[] = [],
    numbers: number[] = [],
    isExternal?: boolean,
    useBeacon?: boolean,
) {
    return scrollV2(
        {
            sessionId,
            deviceId,
            eventType: name,
            userId: userId,
            universeId: process.env.PUBLIC_INSTANCE_ID,
            deviceType: deviceType,
            timestamp: Date.now(), // UTC
            sessionDuration: Date.now() - sessionStartTime, // UTC
            metadata: {
                strings,
                numbers,
            },
            isExternal: isExternal ?? false,
        },
        useBeacon,
    ).catch((e) => {
        // Silently fail
    });
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
